import { getApiEndpoint } from './config.js';
import { checkLogin, checkToken } from './account.js';

/**
 * Get days.
 *
 * @param {object} token - The token to use.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * conversations.
 */
export function getDays(token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/days', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}

/**
 * Save opening time for a day.
 *
 * @param {int} dayId - The id of the day.
 * @param {string} openingTime - The opening time to save.
 * @param {object} token - The token to use.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * conversation.
 */
export function saveDayOpeningTime(dayId, openingTime, token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/days/' + dayId, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
    body: JSON.stringify([{
      op: 'set',
      fields: {
        opening_time: openingTime,
      },
    }]),
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}

/**
 * Save closing time for a day.
 *
 * @param {int} dayId - The id of the day.
 * @param {string} closingTime - The closing time to save.
 * @param {object} token - The token to use.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * conversation.
 */
export function saveDayClosingTime(dayId, closingTime, token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/days/' + dayId, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
    body: JSON.stringify([{
      op: 'set',
      fields: {
        closing_time: closingTime,
      },
    }]),
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}



// WEBPACK FOOTER //
// ./src/utility/day.js